export const calcEipPrice = {
    basePath: '/networkapi',
    params: {
        Action: 'CalculateProduct',
        Service: 'eip',
        Version: '2016-03-04',
        source: 'eip'
    },
    method: 'get'
};
export const updateBandWidth = {
    basePath: '/networkapi',
    params: {
        Action: 'CreateProduct',
        Service: 'eip',
        Version: '2016-03-04',
        source: 'eip'
    },
    method: 'get'
};